import z from 'zod';

export const requirementSchema = z
	.object({
		key: z.string(),
		name: z.string(),
		type: z.string().optional(),
		validator: z.object({
			type: z.string(),
			docType: z.string().optional(),
		}),
	})
	.describe('Requirement');

export const requirementsSchema = z.array(requirementSchema).describe('Requirements');
